import React from 'react';
import placeholder from "images/placeholder-small.png";
import placeholderAvatar from "data/avatars/avatar.jpg";
import { useNavigate } from 'react-router-dom';

const AdvertisementCard = (props: any) => {

    const navigate = useNavigate();

    const getDateFormated = (date: any) => {
        
        const months = [
            "janeiro",
            "fevereiro",
            "março",
            "abril",
            "maio",
            "junho",
            "julho",
            "agosto",
            "setembro",
            "outubro",
            "novembro",
            "dezembro",
        ];

        const dateObject = new Date(date);
        const day = dateObject.getDate();
        const month = months[dateObject.getMonth()];
        const year = dateObject.getFullYear();

        return `${day} de ${month}, ${year}`;
    }

    return (
        <div className="max-w-[300px] h-[400px] bg-white dark:bg-gray-600 rounded-3xl overflow-hidden shadow-md cursor-pointer" onClick={() => navigate(`/classificados/${props.id}`)}>
            <img
                className="w-[300px] h-[220px] object-cover"
                alt="Item image"
                src={props.adImg}
                onError={(e: any) => { e.target.src = placeholder }}
            />
            <div className="px-4 pt-3 flex-col w-[300px] h-100 flex">

                <span className="font-semibold text-sm line-clamp-1 w-full">{props.adTitle}</span>
                <span className="h-[33px] mt-1 text-primary-600 text-sm w-full line-clamp-2 leading-4 space-y-10" dangerouslySetInnerHTML={{ __html: props.adDescription }}></span>
                <span className="font-bold text-sm my-2 line-clamp-1 w-full">{props.adPrice}</span>

                <div className="flex items-center justify-between mt-3">
                    <img
                        className="w-[40px] h-[40px] mr-2 object-cover rounded-full"
                        alt="Author photo"
                        src={props.authorImg}
                        onError={(e) => (e.currentTarget.src = placeholderAvatar)}
                    />
                    <span className="text-xs font-medium w-full leading-4 space-y-10">{props.authorName}</span>
                    <span className="text-xs text-primary-600 w-full leading-4 space-y-10">• {getDateFormated(props.adDate) ?? ''}</span>
                </div>
            </div>
        </div>
    )
}

export default AdvertisementCard;